import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import Typography from "@insite/mobius/Typography";
import Clickable from "@insite/mobius/Clickable";
import { loyaltyRewards } from "@NA/Widgets/LoyaltyRewards/LoyaltyStyles";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import ADIRewardsLogo from "@NA/Icons/ADIRewardsLogo";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";

let styles = loyaltyRewards;

interface OwnProps {
    loyaltyModel: boolean;
    closePopup: Function;
}

export const LoyaltyRewardsUser = ({ loyaltyModel = true, closePopup }: OwnProps) => {
    styles = loyaltyRewards?.LoyaltyRewardsStyle;
    const rewardsRef = useRef<HTMLDivElement>(null);
    const userRoles = useSelector((state: CustomApplicationState) => state.context.session.userRoles);
    const isProRewardsUser = userRoles && userRoles.includes("ADIProRewards");
    const loyaltyStateStore = useSelector((state: CustomApplicationState) => state.ADIGlobalData.loyaltyRewardStore);
    
    const hmiRewardsSettingSettings:any = useSelector(
        (state: CustomApplicationState) => state.context.settings.settingsCollection.hmiRewardsSettingSettings,
    );
    const userloyaltyState = useSelector((state: CustomApplicationState) => state.ADIGlobalData?.loyaltyRewardUserStore);
    const userNameSession= useSelector((state:CustomApplicationState) => state.context.session.userName?.toLocaleLowerCase());
    const emailLTY= userloyaltyState.user.email!= undefined ? userloyaltyState.user.email?.toLocaleLowerCase() : ""
    const showRewardsSlider=(userloyaltyState.user.isEnrolled==false && userNameSession==emailLTY && !isProRewardsUser && 
        (userloyaltyState.user.status?.toLocaleUpperCase()=="A" || 
        userloyaltyState.user.status?.toLocaleUpperCase()=="B" ||
        userloyaltyState.user.status?.toLocaleUpperCase()=="O"));

    const dispatch = useDispatch();

    const handleScrollToRewardsView = () => {
        const element = document.querySelector('[data-test-selector="rewards"]');
        const elementHeader = document.querySelector('[data-test-selector="header"]');
        if (element && elementHeader) {
            const elementRect = element.getBoundingClientRect();
            const elementRectHeader = elementHeader.getBoundingClientRect();
            setTimeout(() => {
                window.scrollTo({
                    top: elementRect.top + window.scrollY - elementRectHeader.height - 20,
                    behavior: "smooth",
                });
            }, 20);
        }
    };

    const activateyourAccountclick = () => {
            let currentDateTime = new Date();
			window.open('/api/v1/singlesignon/verifyuser?param=' + currentDateTime.toString());
    };

    useEffect(() => {
        if (loyaltyStateStore.isAdIProRewardsLoaded) {
            setTimeout(() => {
                handleScrollToRewardsView();
            }, 20);
            dispatch({
                type: "AccountPage/ProRewardReset",
            });
        }
    }, [loyaltyStateStore]);

    useEffect(() => {
        if (loyaltyStateStore.isMyAccountPageReloaded) {
            setTimeout(() => {
                handleScrollToRewardsView();
            }, 100);
        }
        return () => {
            if (loyaltyStateStore.isMyAccountPageReloaded) {
                setTimeout(() => {
                    dispatch({
                        type: "AccountPage/RouteDeactivate",
                    });
                }, 3000);
            }
        };
    }, []);

   
    return (
        <>
            {(!isProRewardsUser && userloyaltyState.isLoading) ? (
                <LoadingSpinner size={15} style={{ position: "absolute", right: "50%" }} />
            ) : (
                <>
                    {
                        <>
                            {styles && !isProRewardsUser && userloyaltyState.user && showRewardsSlider && (
                                <>
                                    <StyledWrapper ref={rewardsRef} data-test-selector="rewards">
                                        <GridContainer
                                            {...(loyaltyModel ? styles.gridContainer : styles.gridContainermodal)}>
                                            <GridItem
                                                {...(loyaltyModel ? styles.GridItem : styles.GridItemLogo)}
                                                width={loyaltyModel ? [12, 12, 12, 2, 2] : [12]}>
                                                    <ADIRewardsLogo />
                                            </GridItem>
                                            <GridItem width={12} style={{ paddingBottom: 0  }}>
                                                    <GridItem width={[12, 12, 12, 12, 12]} style={{ paddingBottom: 0  }}>
                                                        <Typography style={{ fontSize:16, fontWeight: 400, fontFamily:"Nunito Sans", color:'#000' }}>
                                                            {translate(hmiRewardsSettingSettings.invitedUserRewardsSliderText1)}
                                                        </Typography>
                                                    </GridItem>
                                            </GridItem>
                                            <GridItem width={12} style={{ paddingBottom: 0  }}>
                                                    <GridItem width={[12, 12, 12, 12, 12]} style={{ paddingBottom: 0  }}>
                                                        <Typography style={{ fontSize:16, fontWeight: 400, fontFamily:"Nunito Sans", color: '#000'  }}> 
                                                            {translate(hmiRewardsSettingSettings.invitedUserRewardsSliderText2)} 
                                                        </Typography>
                                                    </GridItem>
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer
                                            {...(loyaltyModel ? styles.loyaltyContainer : styles.loyaltyContainerModal)}
                                        >
                                            
                                            <GridItem width={12}  >
                                                <GridItem width={[12, 12, 12, 2, 2]}  {...(styles.browseAndRedeemModalactivate)
                                            } >
                                                    <Clickable
                                                        {...(loyaltyModel ? styles.loyaltyRedeemBtn : styles.loyaltyRedeemBtnModal)}
                                                        onClick={activateyourAccountclick} target="_blank" data-ga-promo="ADI-Rewards_Activate_Your_Account"
                                                    >
                                                        {" "}
                                                        {translate("Activate Your Account")}{" "}
                                                    </Clickable>
                                                </GridItem>
                                            </GridItem>
                                        </GridContainer>
                                    </StyledWrapper>
                                </>
                            )}
                        </>
                    }
                </>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: LoyaltyRewardsUser,
    definition: {
        group: "My Account",
        displayName: "ADI Loyality Invited User",
        icon: "rewards",
    },
};

export default widgetModule;
